import { combineReducers } from "redux";
import auth from './auth/reducer';
import purchaseSim from './inventory/purchaseSim/reducer'
import generic from './generic/reducer'
import reports from './reports/reducer'
import inventoryTransfer from './inventory/inventoryTransfer/reducer'
import dealers from './dealer/reducer';
import activation from './activation/reducer'
import dealer from './dealer/reducer';


const rootReducer = combineReducers({
  auth,
  purchaseSim,
  generic,
  reports,
  inventoryTransfer,
  dealers,
  activation,
  dealer,
});
export default rootReducer;